const APP_ENV = window.__ENV__?.REACT_APP_APP_ENV || 'prod';

let LOG_LEVEL;

switch (APP_ENV) {
    case 'prod':
        LOG_LEVEL = 'warn';
        break;
    case 'sandbox':
        LOG_LEVEL = 'warn';
        break;
    case 'development':
        LOG_LEVEL = 'log';
        break;
    case 'test':
        LOG_LEVEL = 'log';
        break;
    default:
        LOG_LEVEL = 'log';
        break;
}

export { APP_ENV, LOG_LEVEL };
